import { resolveApiUrl } from "~/utils/url/urlResolver";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import { getCsrfValue } from "~/common/utils/ApiHelper";

export const FccAction = {
  BannerClick: "BANNERCLICK",
  IconClick: "ICONCLICK",
  DownloadExcel: "DOWNLOADEXCEL",
  DownloadCsv: "DOWNLOADCSV",
  CreateQuoteForFcc: "CREATEQUOTEFORFCC",
  CreateQuoteForAll: "CREATEQUOTEFORALL",
  BulkEntry: "BULKENTRY",
  Login: "LOGIN",
  AddToWishlist: "ADDTOWISHLIST",
  AddToQuote: "ADDTOQUOTE",
  SearchBar: "SEARCHBAR",
  TreeTabSeries: "TABSERIESVALUE",
  TreeTabHierarchy: "TABHIERARCHYVALUE",
  TreeTabPlant: "TABPLANTVALUE",
  CustomerRelevant: "CUSTOMERRELEVANT",
  SelectProduct: "SELECTPRODUCT",
} as const;

const url = resolveApiUrl("/api/fcc/trackAction");

type ActionType = (typeof FccAction)[keyof typeof FccAction];
type Data =
  | ActionType
  | { actionType: ActionType; actionContent?: string; quantity?: number; netPrice?: number; priceUnit?: number };

export function trackFccAction(data: Data) {
  if (userHasPermission(Permission.CanOpenFCC)) {
    fetch(url, {
      body: JSON.stringify(getBody(data)),
      /*
      The keepalive option can be used to allow the request to outlive the page.
      Fetch with the keepalive flag is a replacement for the Navigator.sendBeacon() API.

      Source: https://developer.mozilla.org/en-US/docs/Web/API/fetch#parameters
       */
      keepalive: true,
      cache: "no-cache",
      credentials: "same-origin",
      method: "POST",
      mode: "cors",
      headers: {
        "content-type": "application/json",
        CSRFToken: getCsrfValue(),
      },
    });
  }
}

function getBody(data: Data) {
  if (typeof data === "string") {
    return { actionType: data };
  }
  return data;
}
